<template>
    <div>
        <Pane :bottom="15">
            <template>
                <span>回款明细管理，跟踪每笔收款记录</span>
            </template>
        </Pane>
        <a-card class="container">
            <a-form layout="inline" @keyup.enter.native="query" ref="queryForm" :form="form">
                <a-form-item>
                    <a-input
                            v-decorator="['customerName']"
                            placeholder="客商"
                    />
                </a-form-item>

                <a-form-item>
                    <a-input
                            v-decorator="['invoiceNo']"
                            placeholder="发票号"
                    />
                </a-form-item>

                <a-form-item>
                    <a-input
                            v-decorator="['projectCode']"
                            placeholder="项目编码"
                    />
                </a-form-item>

                <a-form-item>
                    <a-input
                            v-decorator="['voucherNo']"
                            placeholder="凭证号"
                    />
                </a-form-item>

                <a-form-item>
                    <a-input
                            v-decorator="['deptName']"
                            placeholder="责任部门"
                    />
                </a-form-item>

                <a-form-item>
                    <a-select
                            v-decorator="['incomeType']"
                            placeholder="收入性质"
                            style="width:150px"
                            allow-clear
                    >
                        <a-select-option v-for="item in incomeTypeList" :key="item.value" :value="item.value">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-space style="margin-top: 4px">
                    <a-button type="primary" @click="query">查询</a-button>
                    <a-button @click="reset">重置</a-button>
                    <a-button @click="handleExport">导出</a-button>
                    <a-button @click="handleImport">导入</a-button>
                    <a-button @click="handleDownloadTemplate">下载模板</a-button>
                </a-space>
            </a-form>

            <!-- 隐藏的文件上传 input -->
            <input
                ref="fileInput"
                type="file"
                accept=".xlsx,.xls"
                style="display: none"
                @change="onFileChange"
            />

            <a-table
                    style="margin-top: 15px;"
                    :columns="columns"
                    :data-source="dataSource"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    row-key="id"
                    bordered
                    :scroll="{ x: 2000 }"
            >
    <template slot="amountRender" slot-scope="text">
        {{ text ? Number(text).toFixed(2) : '' }}
    </template>
    <template slot="incomeTypeRender" slot-scope="text">
        {{ findSingleDictName('incomeType', text) || text }}
    </template>
                <template slot="action" slot-scope="text, record">
                    <a @click="handleEdit(record)">编辑</a>
                </template>
            </a-table>

            <IncomeEditModal
                :visible="editVisible"
                :record="editRecord"
                @ok="fetchData"
                @close="editVisible = false"
            />
        </a-card>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchIncomeDetailList, importIncomeDetail, exportIncomeDetail, downloadIncomeDetailTemplate } from "@/api/finance/income-detail";
import { saveAs } from "file-saver";
import IncomeEditModal from "./components/incomeEditModal";

const columns = [
    // { title: '凭证号', dataIndex: 'voucherNo', key: 'voucherNo', width: 120 },
    // { title: '收款处理单', dataIndex: 'receiptFormNo', key: 'receiptFormNo', width: 120 },
    // { title: '金蝶应收单据号', dataIndex: 'kingdeeReceivableNo', key: 'kingdeeReceivableNo', width: 140 },
    // { title: '客商', dataIndex: 'customerName', key: 'customerName', width: 150 },
    // { title: '发票号', dataIndex: 'invoiceNo', key: 'invoiceNo', width: 130 },
    { title: '收费日期', dataIndex: 'chargeDate', key: 'chargeDate', width: 120 },
    { title: '项目编码', dataIndex: 'contractCode', key: 'contractCode', width: 120 },
    { title: '项目内容', dataIndex: 'contractName', key: 'contractName', width: 200 },
    { title: '回款金额(元)', dataIndex: 'amount', key: 'amount', width: 130, scopedSlots: { customRender: 'amountRender' } },
    { title: '流水来源', dataIndex: 'source', key: 'source', width: 120 },
    { title: '责任部门', dataIndex: 'deptName', key: 'deptName', width: 130 },
    { title: '收入性质', dataIndex: 'incomeType', key: 'incomeType', width: 120, scopedSlots: { customRender: 'incomeTypeRender' } },
    { title: '发票号', dataIndex: 'invoiceNo', key: 'invoiceNo', width: 130 },
    { title: '备注', dataIndex: 'remark', key: 'remark', width: 200, ellipsis: true },
    { title: '操作', dataIndex: 'action', key: 'action', width: 80, scopedSlots: { customRender: 'action' }, fixed: 'right' },
];

export default {
    name: "IncomeDetail",
    components: { IncomeEditModal },
    computed: {
        ...mapGetters("setting", ["findDataDict", "findSingleDictName"]),
        incomeTypeList() {
            return this.findDataDict("incomeType") || [];
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            columns,
            dataSource: [],
            loading: false,
            editVisible: false,
            editRecord: {},
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                pageSizeOptions: ['10','20', '50', '100', '200'],
                showQuickJumper: true,
                showTotal: total => `共 ${total} 条`,
            },
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        handleImport() {
            this.$refs.fileInput.value = '';
            this.$refs.fileInput.click();
        },
        handleEdit(record) {
            this.editRecord = { ...record };
            this.editVisible = true;
        },
        async onFileChange(e) {
            const file = e.target.files[0];
            if (!file) return;

            const loadingMsg = this.$message.loading('正在导入，请稍候...', 0);
            try {
                const res = await importIncomeDetail(file);
                const data = res;
                const successCount = data.successCount || 0;
                const failCount = data.failCount || 0;
                const errorList = data.errorList || [];

                loadingMsg();
                if (failCount > 0) {
                    const h = this.$createElement;
                    const errorItems = errorList.map((item, idx) => {
                        return h('div', {
                            style: 'padding: 4px 0; border-bottom: ' + (idx < errorList.length - 1 ? '1px solid #f0f0f0' : 'none')
                        }, [
                            h('span', { style: 'color: #ff4d4f; margin-right: 8px; font-weight: bold;' }, '第' + (item.rowIndex || '?') + '行'),
                            h('span', {}, item.err || '未知错误'),
                        ]);
                    });
                    this.$confirm({
                        title: '导入结果',
                        content: h('div', { style: 'max-height: 400px; overflow-y: auto; font-size: 13px;' }, [
                            h('div', { style: 'margin-bottom: 12px; padding: 8px 12px; background: #fff7e6; border-radius: 4px;' }, '成功 ' + successCount + ' 条，失败 ' + failCount + ' 条'),
                            h('div', { style: 'font-weight: bold; margin-bottom: 4px;' }, '错误详情：'),
                            h('div', {}, errorItems),
                        ]),
                        width: 700,
                        okText: '关闭',
                        cancelButtonProps: { style: 'display: none' },
                    });
                } else {
                    this.$message.success(`导入完成：成功 ${successCount} 条`);
                }
                await this.fetchData();
            } catch (e) {
                loadingMsg();
                console.error("导入失败", e);
                this.$message.error("导入失败：" + (e.message || '未知错误'));
            }
        },
        async handleExport() {
            const formValues = this.form.getFieldsValue();
            const params = {
                pageNum: 1,
                pageSize: 10000,
                voucherNo: formValues.voucherNo,
                customerName: formValues.customerName,
                invoiceNo: formValues.invoiceNo,
                projectCode: formValues.projectCode,
                deptName: formValues.deptName,
                incomeType: formValues.incomeType,
            };

            try {
                const blob = await exportIncomeDetail(params);
                saveAs(blob, "收入明细.xlsx");
            } catch (e) {
                console.error("导出失败", e);
                this.$message.error("导出失败");
            }
        },
        async handleDownloadTemplate() {
            try {
                const blob = await downloadIncomeDetailTemplate();
                saveAs(blob, "收入明细导入模板.xlsx");
            } catch (e) {
                console.error("下载模板失败", e);
                this.$message.error("下载模板失败");
            }
        },
        getFormValues() {
            return this.form.getFieldsValue();
        },
        handleTableChange(pagination) {
            this.pagination = { ...this.pagination, ...pagination };
            this.fetchData();
        },
        async query() {
            this.pagination.current = 1;
            await this.fetchData();
        },
        async reset() {
            this.form.resetFields();
            this.pagination.current = 1;
            await this.fetchData();
        },
        async fetchData() {
            this.loading = true;
            const { current, pageSize } = this.pagination;
            const params = this.getFormValues();

            const queryParams = {
                pageNum: current,
                pageSize,
                voucherNo: params.voucherNo,
                customerName: params.customerName,
                invoiceNo: params.invoiceNo,
                projectCode: params.projectCode,
                deptName: params.deptName,
                incomeType: params.incomeType,
            };

            try {
                const res = await fetchIncomeDetailList(queryParams);
                this.dataSource = (res?.list || []).map((item, idx) => ({
                    ...item,
                    id: item.id || `${current}-${idx}`
                }));
                this.pagination.total = res?.totalSize || 0;
            } catch (e) {
                console.error("查询失败", e);
            } finally {
                this.loading = false;
            }
        },
    }
};
</script>

<style scoped>
.container {
    background-color: #fff;
    padding: 24px 15px;
}
</style>
